import { Link } from 'react-router-dom';

export default function NotFound() {
  return (
    <div className="flex min-h-[70vh] flex-col items-center justify-center px-4 text-center">
      <p className="font-heading text-[100px] font-black leading-none text-primary-900 md:text-[140px]">
        404
      </p>
      <h1 className="mt-2 font-heading text-xl font-bold text-foreground-950 md:text-2xl">
        页面走丢了
      </h1>
      <p className="mt-3 max-w-sm text-sm leading-relaxed text-foreground-500">
        你访问的页面不存在或已被移除，返回首页继续浏览精彩短视频吧。
      </p>
      <div className="mt-6 flex flex-wrap items-center justify-center gap-3">
        <Link
          to="/"
          className="rounded-full bg-primary-500 px-6 py-2.5 text-sm font-semibold text-foreground-950 transition-colors hover:bg-primary-400"
        >
          返回首页
        </Link>
        <Link
          to="/search"
          className="rounded-full border border-background-300/70 px-6 py-2.5 text-sm font-medium text-foreground-800 transition-colors hover:border-primary-600 hover:text-primary-300"
        >
          去搜索
        </Link>
      </div>
    </div>
  );
}